// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"695":"3a4510d11907e2e3","9633":"d5feb23a95b51093"}[chunkId] + ".css";
};